/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SetDefs from './defs.defs.js'

const $nsid = 'tools.ozone.set.upsertSet'

export { $nsid }

/** Create or update set metadata */
const main = l.procedure(
  $nsid,
  l.params(),
  l.payload(
    'application/json',
    l.ref<SetDefs.Set>((() => SetDefs['set']) as any),
  ),
  l.payload(
    'application/json',
    l.ref<SetDefs.SetView>((() => SetDefs.setView) as any),
  ),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
